module.exports = __webpack_public_path__ + "img/noContent.27d3beff.png";